const $=(s,r=document)=>r.querySelector(s);
const $$=(s,r=document)=>[...r.querySelectorAll(s)];
const RM=matchMedia("(prefers-reduced-motion: reduce)").matches;
const FINE=matchMedia("(pointer: fine)").matches;
const TAU=Math.PI*2;
/* smooth on every device: a phone that saves data or has little memory starts on the lighter level (see assets/nor-steel.js);
   a level measured earlier in this visit is kept */
(function(){ let l=0; try{ l=+sessionStorage.getItem("norPerf")||0; }catch(e){}
  const c=navigator.connection; if((c&&c.saveData)||(navigator.deviceMemory&&navigator.deviceMemory<=2)) l=Math.max(l,1);
  if(l) document.documentElement.dataset.norPerf=l; })();
const PATH=new Path2D($("#mark path").getAttribute("d"));
const MW=1000, MH=893.6, AR=MH/MW;
const SPR={};
function sprite(fill){
  if(SPR[fill]) return SPR[fill];
  const c=document.createElement("canvas"), w=420;
  c.width=w; c.height=Math.round(w*AR);
  const k=c.getContext("2d");
  k.setTransform(w/MW,0,0,w/MW,0,0); k.fillStyle=fill; k.fill(PATH);
  SPR[fill]=c; return c;
}
function stamp(c,x,y,size,rot,alpha,fill){
  const sp=sprite(fill||"#F2F4F7"), h=size*AR;
  c.save(); c.translate(x,y); if(rot) c.rotate(rot);
  c.globalAlpha=alpha; c.drawImage(sp,-size/2,-h/2,size,h); c.restore();
}
function fit(cv){
  const r=cv.getBoundingClientRect();
  if(!r.width||!r.height) return null;
  const d=Math.min(devicePixelRatio||1,2);
  cv.width=Math.round(r.width*d); cv.height=Math.round(r.height*d);
  const c=cv.getContext("2d"); c.setTransform(d,0,0,d,0,0);
  return {c,W:r.width,H:r.height};
}
/* star cursor + nav — after the body exists */
function __chrome(){
if(FINE&&!RM){
  const cur=$("#cur");
  if(cur){
    let mx=0,my=0,ux=0,uy=0,spin=0,raf=0;
    function loop(){   // runs only while the star is still catching up with the mouse
      const dx=mx-ux,dy=my-uy;
      ux+=dx*0.18; uy+=dy*0.18;
      spin+=Math.min(Math.hypot(dx,dy),46)*0.55;
      cur.style.transform=`translate3d(${ux}px,${uy}px,0) translate(-50%,-50%) rotate(${spin}deg)`;
      raf=Math.abs(dx)+Math.abs(dy)>0.1?requestAnimationFrame(loop):0;
    }
    addEventListener("pointermove",e=>{mx=e.clientX;my=e.clientY; if(!raf) raf=requestAnimationFrame(loop);},{passive:true});
    loop();
    document.addEventListener("pointerover",e=>{
      cur.classList.toggle("hot",!!e.target.closest("a,button,input,[data-hot]"));
    });
  }
}
  const navs=$$(".nav");
  if(navs.length){
    const sync=()=>{const s=scrollY>40; for(const n of navs) n.classList.toggle("stuck",s);};
    addEventListener("scroll",sync,{passive:true});
    sync();
  }

  /* the wordmark turns on one shared clock, so switching pages or clicking it never restarts the spin */
  const spins=$$(".spin-in:not([data-still])");   // "Stop the 3D spin" in Theme settings → Logo marks a wordmark still
  if(spins.length){
    if(RM){ spins.forEach(s=>s.style.transform="rotateY(-22deg)"); }
    else{
      const DUR=7000;   // one full turn every 7 s
      if(spins[0].animate&&document.timeline){
        // turned by the browser's animation engine instead of the page script, so it stays smooth while the page is busy;
        // every copy runs on the same page clock, so switching pages never restarts the spin
        const anims=spins.map(s=>{ const a=s.animate([{transform:"rotateY(0deg)"},{transform:"rotateY(360deg)"}],{duration:DUR,iterations:Infinity}); a.startTime=0; return a; });
        // while the 3D steel NØR covers it, the plain wordmark is hidden: rest it, and pick the clock up again when it shows
        const rest=()=>{ const off=document.documentElement.classList.contains("nor3d");
          for(const a of anims){ if(off){ if(a.playState==="running") a.pause(); } else if(a.playState!=="running"){ a.play(); a.startTime=0; } } };
        new MutationObserver(rest).observe(document.documentElement,{attributes:true,attributeFilter:["class"]}); rest();
      }else{
        (function turn(now){
          const deg=(now%DUR)/DUR*360;
          for(const s of spins) s.style.transform="rotateY("+deg+"deg)";
          requestAnimationFrame(turn);
        })(performance.now());
      }
    }
  }
}
if(document.readyState==="loading") addEventListener("DOMContentLoaded",__chrome); else __chrome();
let _tt;
function toast(msg){
  const t=$("#toast"); if(!t) return;
  t.textContent=msg; t.classList.add("on");
  clearTimeout(_tt); _tt=setTimeout(()=>t.classList.remove("on"),2200);
}
/* the gate holds still under a finger, on older iPhones too: a drag only moves the light, never the page */
function __gateHold(){ const g=$("#gate"); if(!g) return;
  g.addEventListener("touchmove",e=>{ if(e.cancelable) e.preventDefault(); },{passive:false});
  g.addEventListener("gesturestart",e=>e.preventDefault()); }
if(document.readyState==="loading") addEventListener("DOMContentLoaded",__gateHold); else __gateHold();